import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import { CompetitionsMarquee } from '../components/CompetitionsMarquee';
import Banner from '../components/Banner';
import FeaturedMatch from '../components/FeaturedMatch';
import Download from '../components/Download';
import Testimonials from '../components/Testimonials';
import Features from '../components/Features';
import DataSources from '../components/DataSources';
import Faq from '../components/Faq';
import CtaFooter from '../components/CtaFooter';

export default function Home() {
  const navigate = useNavigate();
  const goComingSoon = () => navigate('/bientot-disponible');

  return (
    <>
      <Navbar onConnect={goComingSoon} />
      <Hero onConnect={goComingSoon} />
      <div style={{ background: '#070A08' }} className="w-full flex justify-center px-6 py-6">
        <div className="w-full max-w-2xl">
          <CompetitionsMarquee />
        </div>
      </div>
      <Banner />
      <FeaturedMatch onConnect={goComingSoon} />
      <Download onConnect={goComingSoon} />
      <Testimonials />
      <Features />
      <DataSources />
      <Faq />
      <CtaFooter onConnect={goComingSoon} />
    </>
  );
}
